const QuestionnaireStatus = {
  WELCOME: 'WELCOME',
  QUESTIONNAIRE: 'QUESTIONNAIRE',
  SIGNATURE: 'SIGNATURE',
  DOCUMENT_UPLOAD: 'DOCUMENTS',
  REVIEW: 'REVIEW',
};

export default QuestionnaireStatus;
